import { configureStore } from "@reduxjs/toolkit";
import AuthReducer from "./slice/Auth";
import CustomizerReducer from "./slice/Customizer";
import PaginationReducer from "./slice/Pagination";
import KonfigurasiDatabaseReducer from "./slice/KonfigurasiDatabase";
import RiskEventReducer from "./slice/RiskEvent";
import OfficeReducer from "./slice/Office";
import MasterDataReducer from "./slice/MasterData";
import UsersReducer from "./slice/Users";
import ProfileReducer from "./slice/Profile";
import IssuesReducer from "./slice/Issues";
import LaporanReducer from "./slice/Laporan";
import ArchivingReducer from "./slice/Archiving";
import DashboardMemberReducer from "./slice/DashboardMember";
import DashboardAdminReducer from "./slice/DashboardAdmin";
import AuditTrailReducer from "./slice/AuditTrail";
import AppSettingReducer from "./slice/AppSetting";
import ApprovalLogReducer from "./slice/ApprovalLog";
import LoadingSliceReducer from "./slice/LoadingSlice";

export const store = configureStore({
  reducer: {
    auth: AuthReducer,
    customizer: CustomizerReducer,
    pagination: PaginationReducer,
    konfigurasiDatabase: KonfigurasiDatabaseReducer,
    riskEvent: RiskEventReducer,
    office: OfficeReducer,
    masterData: MasterDataReducer,
    users: UsersReducer,
    profile: ProfileReducer,
    issues: IssuesReducer,
    laporan: LaporanReducer,
    archiving: ArchivingReducer,
    dashboardMember: DashboardMemberReducer,
    dashboardAdmin: DashboardAdminReducer,
    auditTrail: AuditTrailReducer,
    appSetting: AppSettingReducer,
    approvalLog: ApprovalLogReducer,
    loadingSlice: LoadingSliceReducer
  },
});

export default store;
